import { Button } from "./ui/button";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Reusable Excel export button.
 * Usage: <ExcelExportButton endpoint="orders" label="Exportar Excel" />
 */
export default function ExcelExportButton({ endpoint, label = "Exportar Excel", filename, ...rest }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await axios.get(`${API}/excel/${endpoint}`, { responseType: "blob" });
      const disp = r.headers["content-disposition"] || "";
      const match = disp.match(/filename="([^"]+)"/);
      const fname = filename || (match ? match[1] : `${endpoint}-${Date.now()}.xlsx`);
      const url = window.URL.createObjectURL(new Blob([r.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
      const a = document.createElement("a");
      a.href = url; a.download = fname; a.click();
      window.URL.revokeObjectURL(url);
      toast.success(`Excel gerado (${fname})`);
    } catch (e) { toast.error("Erro a gerar Excel"); }
    finally { setBusy(false); }
  };
  return (
    <Button variant="outline" onClick={download} disabled={busy} data-testid={`excel-${endpoint}-btn`} {...rest}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <FileSpreadsheet className="h-4 w-4 mr-2 text-emerald-600" />}
      {label}
    </Button>
  );
}
